import * as defaultImport from "@splunk/visualization-context/Provider";
export * from "@splunk/visualization-context/Provider";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
